// Hover intent and single-panel behaviour for the desktop mega menu.
// Click, keyboard and focus-out handling stay with HeaderMenu (details-disclosure.js);
// this only adds what a pointer needs: open on hover, close on leave, one panel at a time.
if (!customElements.get('mega-menu-nav')) {
  class MegaMenuNav extends HTMLElement {
    constructor() {
      super();
      this.openDelay = 90;
      this.switchDelay = 0;
      this.closeDelay = 200;
      this.openTimer = null;
      this.closeTimer = null;
      this.lastPointerType = '';
      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    }

    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('details.mega-menu'));

      this.panels.forEach((details) => {
        const item = details.closest('.mega-nav__item');
        const summary = details.querySelector('summary');
        const content = details.querySelector('.mega-menu__content');
        const backdrop = details.querySelector('.mega-menu__backdrop');

        item.addEventListener('pointerenter', (event) => {
          if (!this.canHover(event)) return;
          this.scheduleOpen(details);
        });

        item.addEventListener('pointerleave', (event) => {
          if (!this.canHover(event)) return;
          this.scheduleClose(details);
        });

        // The backdrop sits inside the item, so reaching it does not fire pointerleave.
        backdrop?.addEventListener('pointerenter', (event) => {
          if (!this.canHover(event)) return;
          this.scheduleClose(details);
        });

        content?.addEventListener('pointerenter', () => this.cancelClose());

        backdrop?.addEventListener('click', () => this.close(details));

        summary.addEventListener('pointerdown', (event) => {
          this.lastPointerType = event.pointerType;
        });

        // A mouse that already opened the panel by hovering should not close it by clicking.
        summary.addEventListener('click', (event) => {
          // event.detail is 0 for clicks synthesized by Enter/Space: keyboard always toggles.
          if (event.detail === 0 || this.lastPointerType !== 'mouse' || !this.hoverQuery.matches) return;
          if (!details.open) return;
          event.preventDefault();
          summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (details.open) this.closeOthers(details);
        });

        details.addEventListener('keyup', (event) => {
          if (event.code !== 'Escape' || !details.open) return;
          this.close(details);
          summary.focus();
        });
      });
    }

    canHover(event) {
      return event.pointerType === 'mouse' && this.hoverQuery.matches;
    }

    scheduleOpen(details) {
      this.cancelClose();
      clearTimeout(this.openTimer);
      if (details.open) return;

      const switching = this.panels.some((panel) => panel !== details && panel.open);
      this.openTimer = setTimeout(() => this.open(details), switching ? this.switchDelay : this.openDelay);
    }

    scheduleClose(details) {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(details), this.closeDelay);
    }

    cancelClose() {
      clearTimeout(this.closeTimer);
    }

    open(details) {
      this.closeOthers(details);
      details.open = true;
    }

    close(details) {
      if (!details.open) return;
      const disclosure = details.closest('header-menu');
      if (disclosure && typeof disclosure.close === 'function') {
        disclosure.close();
      } else {
        details.open = false;
      }
    }

    closeOthers(current) {
      this.panels.forEach((panel) => {
        if (panel !== current) this.close(panel);
      });
    }
  }

  customElements.define('mega-menu-nav', MegaMenuNav);
}
